import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import useSWR from 'swr'
import { server } from '../config'
import { IMainData } from '../interfaces/maindata'

const fetcher = (url: string): Promise<any> => {
  const options: RequestInit = {
    method: 'GET',
  }
  return fetch(url, options).then(r => r.json().then(data => ({ status: r.status, body: data })).catch(_ => ({ status: r.status })))
}

const useFetchMainData = () => {
  // todo add type
  const [state, setState] = useState<IMainData>({} as IMainData)
  const router = useRouter();
  const { data, error } = useSWR(`${server}/maindata`, fetcher)

  useEffect(() => {
    if (data) {
      if (data.status === 200) {
        setState(data.body)
      } else {
        router.replace(`error?status=${data.status}`, window.location.href, { shallow: true })
      }
    }
  }, [data, router]);
  
  return state
}

export default useFetchMainData
